import { useCallback } from "react"

import { useQuery } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { type TUserState, useUser } from "@/3514/hooks"
import Urls from "@/api/urls"
import { ServerStateKeys } from "@/constants"
import { NpsAPI } from "@/models/api/nps"
import { Nps } from "@/models/nps"

const getNps = async () => {
    const { data } = await axiosClient.get(Urls.npsQuestion())
    return data
}

export default function useNps() {
    const { isLoaded }: TUserState = useUser()

    return useQuery<NpsAPI, Error, Nps>({
        queryKey: [ServerStateKeys.Nps],
        queryFn: getNps,
        select: useCallback(data => {
            return new Nps(data)
        }, []),
        enabled: isLoaded
    })
}
